var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-change-card',{staticClass:"tw-m-8",attrs:{"loading":_vm.loading,"projectChange":_vm.projectchange},on:{"updated":_vm.onEdit,"removed":_vm.onDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }